import { useContext } from 'react';
import { GlueAPI } from '../glue';
export var useGlue = function useGlue() {
  return useContext(GlueAPI.Context);
};